import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  CompanyGovernmentAllocationEntryData,
  CompanyGovernmentAllocationEntryResponse,
} from '@/features/privateCompanies/types/companyGovernmentAllocationEntry.type'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export const useCompanyGovernmentAllocationEntry: (
  id: string,
) => UseQueryResult<CompanyGovernmentAllocationEntryData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<CompanyGovernmentAllocationEntryResponse, unknown, CompanyGovernmentAllocationEntryData>({
    queryKey: ['companyGovernmentAllocationEntry', id],
    queryFn: () => privateAxios.get(`/billing/government_allocation_entries/${id}`),
    select: (data) => {
      return data?.data?.data
    },
  })
}
